import { render, staticRenderFns } from "./BFCMBanner.vue?vue&type=template&id=1aaeb196"
import script from "./BFCMBanner.vue?vue&type=script&lang=js"
export * from "./BFCMBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports